import React from 'react';

export const linksToOtherWebsitesMessage = {
  value: 'Links to Other Websites',
  list: [
    {
      value: (
        <>
          The Site may contain links to third-party websites. These are provided
          solely as a convenience to users and as Internet navigation tools, and
          not in any way as an endorsement by Glints of the contents on such
          third-party websites. Unless otherwise stated on the Site, Glints has
          no control over or rights in such third-party websites and is not
          responsible for their availability or security. If users access any
          linked third-party websites, they do so entirely at their own risk.
          Glints shall not be responsible for the contents of any third-party
          websites linked to the Site or any links contained in such third-party
          websites or any changes or updates to the above, and does not make any
          representations or warranties regarding the contents or accuracy of
          materials on such third-party websites. Glints shall not be
          responsible or liable for any loss or damage of any kind arising from
          or in connection with the use of the services or contents of such
          third-party websites. Further, any data or materials posted on the
          Site by any user may be viewed by users of other websites linked to
          the Site and Glints shall not be responsible for any improper use by
          any user or third party other than Glints of any data or materials
          posted on the Site.
        </>
      ),
    },
  ],
};
